import { render, staticRenderFns } from "./BtnInserirAnexoParcelamento.vue?vue&type=template&id=7b379ea3&"
import script from "./BtnInserirAnexoParcelamento.vue?vue&type=script&lang=js&"
export * from "./BtnInserirAnexoParcelamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports